import { is } from 'immutable';
/**
 * Returns the result of merging `newState` into `existingState`.
 *
 * @typeParam T The type of the managed state, assumed to be an
 * [object type](https://www.typescriptlang.org/docs/handbook/2/objects.html)
 */
export function applyState(existingState, newState) {
    if (newState === undefined || Object.keys(newState).length == 0) {
        return existingState;
    }
    return existingState.merge(Object.entries(newState));
}
/**
 * Typed wrapper around membership checking for [[`MapOf`]]'s.
 * Returns true if `newState` has the property given by `name` defined
 * and the value of `newState.get(name)` is different than `current`.
 *
 * See [`Map.has()`](https://immutable-js.com/docs/v4.1.0/Map/#has())
 * and [`is()`](https://immutable-js.com/docs/v4.1.0/is()/).
 *
 * @typeParam T An [object type](https://www.typescriptlang.org/docs/handbook/2/objects.html)
 */
export function isNew(newState, name, current) {
    return newState.has(name) && !is(newState.get(name), current);
}
//# sourceMappingURL=state.js.map